import { render, staticRenderFns } from "./InvitationCreateAccount.vue?vue&type=template&id=e10bf3c8&scoped=true&"
import script from "./InvitationCreateAccount.vue?vue&type=script&lang=ts&"
export * from "./InvitationCreateAccount.vue?vue&type=script&lang=ts&"
import style0 from "./InvitationCreateAccount.vue?vue&type=style&index=0&id=e10bf3c8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e10bf3c8",
  null
  
)

export default component.exports